import React, { useEffect, useState } from 'react'
import template from 'lodash/template'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { useDonation } from '../use-donation'
import { selectFundraisingPage } from '../../../store/fundraisingPage'
import { selectTagPage } from '../../../store/tagPage'
import { selectTeam } from '../../../store/team'

export const withInjectParams = ComponentToWrap => {
  const Component = ({
    router: {
      location: { pathname, query } = {}
    } = {},
    ...props
  }) => {
    const {
      page,
      tagPage,
      team,
      injectData
    } = props

    const isTeamRoute = pathname.indexOf('/teams') === 0
    const { data: donation = {} } = useDonation(query['donation-id'])

    const spreadDataProps = () => ({
      donation,
      page,
      tagPage,
      team,
      ...tagPage,
      ...donation,
      ...isTeamRoute ? { ...page, ...team } : { ...team, ...page },
      ...injectData
    })

    const defaultKeys = ['active', 'amount_x2', 'amount_x3', 'amount_x4', 'amount', 'answer_1', 'answer_2', 'answer_3', 'campaign', 'charity', 'donationUrl', 'event', 'event', 'first_name', 'id', 'image', 'name', 'name', 'owner', 'raised', 'raised', 'slug', 'story', 'target', 'type', 'url', 'uuid']
    const defaultParams = {
      ...defaultKeys.reduce((acc, key) => ({ ...acc, [key]: null }), {}),
      ...spreadDataProps()
    }

    const [params, setParams] = useState(defaultParams)

    useEffect(() => {
      const amount = query.amount || donation.amount || 0

      setParams({
        ...defaultParams,
        amount,
        amount_x2: amount * 2,
        amount_x3: amount * 3,
        amount_x4: amount * 4,
        name: query.name || donation.name,
        first_name: query.first_name,
        answer_1: query.answer_1,
        answer_2: query.answer_2,
        answer_3: query.answer_3,
        ...spreadDataProps()
      })
    }, [donation.id, query, page, tagPage, team, injectData])

    const injectParams = (str) => template(str)(params)

    return (
      <ComponentToWrap
        injectParams={injectParams}
        {...props}
      />
    )
  }

  const mapStateToProps = (state, props) => ({
    page: selectFundraisingPage(state, props),
    tagPage: selectTagPage(state, props),
    team: selectTeam(state, props)
  })

  return compose(
    connect(mapStateToProps),
    withRouter
  )(Component)
}

const InjectParams = withInjectParams(
  ({
    children,
    injectParams
  }) => (
    <span>
      {injectParams(children)}
    </span>
  )
)

export default InjectParams
